import { Space, Tag } from "antd";
import type { CSSProperties, ReactNode } from "react";
import { Children } from "react";

const DEFAULT_WRAPPABLE_TAG_LIST_MAX_WIDTH = "22rem";
const WRAPPABLE_TAG_LIST_SPACE_STYLE = { display: "flex", width: "100%" } as const;
const WRAPPABLE_TAG_STYLE = { whiteSpace: "normal", wordBreak: "break-word" } as const;

export type WrappableTagListProps = {
  labels?: string[];
  children?: ReactNode;
  empty?: ReactNode;
  maxWidth?: CSSProperties["maxWidth"];
};

export function WrappableTagList({
  labels = [],
  children,
  empty = "-",
  maxWidth = DEFAULT_WRAPPABLE_TAG_LIST_MAX_WIDTH,
}: WrappableTagListProps) {
  const content =
    children ??
    labels.map((label) => (
      <Tag key={label} style={WRAPPABLE_TAG_STYLE}>
        {label}
      </Tag>
    ));
  if (Children.count(content) === 0) {
    return empty;
  }
  return (
    <div style={{ width: "100%", maxWidth }}>
      <Space size={[4, 4]} wrap style={WRAPPABLE_TAG_LIST_SPACE_STYLE}>
        {content}
      </Space>
    </div>
  );
}
